module.exports = __webpack_public_path__ + "assets/ac318023614dc75831164159b982a011.png";